import { Add, ChatBubbleOutline, DeleteOutline, SupportAgent, WavingHand } from '@mui/icons-material'
import { Button, IconButton, List, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material'
import styles from './ai-chat.module.css'
import { ChatSession } from './use-chat-sessions'

const ChatSessionList = ({
	sessions,
	onSelectSession,
	onDeleteSession,
	onNewChat,
}: {
	sessions: ChatSession[]
	onSelectSession: (id: string) => void
	onDeleteSession: (id: string) => void
	onNewChat: () => void
}) => {
	return (
		<div className={styles['ai-container']}>
			<div className={styles['header']}>
				<div className={styles['header-content']}>
					<SupportAgent className={styles['header-icon']} />
					<Typography variant='h6' className={styles['header-title']}>
						Hello <WavingHand className={styles['wave-icon']} />
					</Typography>
				</div>
			</div>
			<div className={styles['session-list-content']}>
				{sessions.length === 0 ? (
					<div className={styles['empty-state']}>
						<ChatBubbleOutline className={styles['empty-icon']} />
						<Typography variant='body1' className={styles['empty-text']}>
							No chats yet
						</Typography>
						<Typography variant='body2' className={styles['empty-subtext']}>
							Click <strong>New Chat</strong> to get started
						</Typography>
					</div>
				) : (
					<List disablePadding>
						{sessions.map((session) => (
							<ListItemButton
								key={session.id}
								onClick={() => onSelectSession(session.id)}
								className={styles['session-item']}
							>
								<ListItemIcon className={styles['session-item-icon']}>
									<ChatBubbleOutline />
								</ListItemIcon>
								<ListItemText
									primary={session.title}
									secondary={session.createdAt.toLocaleString(undefined, {
										month: 'short',
										day: 'numeric',
										year: 'numeric',
										hour: 'numeric',
										minute: '2-digit',
									})}
									primaryTypographyProps={{ noWrap: true }}
								/>
								<IconButton
									size='small'
									className={styles['delete-btn']}
									onClick={(e) => {
										e.stopPropagation()
										onDeleteSession(session.id)
									}}
									aria-label='Delete chat'
								>
									<DeleteOutline fontSize='small' />
								</IconButton>
							</ListItemButton>
						))}
					</List>
				)}
			</div>
			<div className={styles['new-chat-footer']}>
				<Button
					variant='contained'
					startIcon={<Add />}
					onClick={onNewChat}
					className={styles['new-chat-btn']}
					fullWidth
				>
					New Chat
				</Button>
			</div>
		</div>
	)
}

export default ChatSessionList
